import Banner from '../Banner/Banner'
import ServicesCards from '../ServicesCards/ServicesCards'
import ProductTour from '../ProductTour/ProductTour'
import Outcome from '../Outcome/Outcome'
import GlobalMedia from '../GlobalMedia/GlobalMedia'
import Contact from '../Contact/Contact'
import ProductMilestone from '../ProductMilestone/ProductMilestone'
// import LeadershipReflection from '../LeadershipReflection/LeadershipReflection'

import styles from './HomeComponent.module.scss'

function HomeComponent({ data }) {
  const {
    bannerdata,
    globalmedia: globalMedia,
    marquees,
    outcomeData,
    productTour,
    services,
    transform_payment,
  } = data || {}

  return (
    <>
      <div className={styles.bannerContainer}>
        {bannerdata && <Banner widgetDetails={bannerdata} />}
      </div>
      <div className={styles.mainContainer}>
        {services && <ServicesCards widgetDetails={services} />}
        {productTour && <ProductTour widgetDetails={productTour} />}
        {outcomeData && <Outcome widgetDetails={outcomeData} />}
        {transform_payment && (
          <ProductMilestone widgetData={transform_payment} />
        )}
        {/* <LeadershipReflection widgetDetails={leadershipData} /> */}
        {globalMedia && <GlobalMedia widgetDetails={globalMedia} />}
        {marquees && <Contact marquees={marquees} />}
      </div>
    </>
  )
}

export default HomeComponent
